__turbopack_context__.v({
  "className": "sora_3f93c0d-module___JIDNa__className",
});
